import * as React from 'react';
import * as styles from './styles.css';

import { MoreFiltersBtn } from './components/MoreFiltersBtn';
import { IPreciseFiltersProps } from './types';
import { AllFiltersModal } from './components/AllFiltersModal';

export const _PreciseFilters: React.ForwardRefRenderFunction<HTMLDivElement, IPreciseFiltersProps> = (props, ref) => {
  const { mainBtnCount, onMoreFiltersButtonClick, moreFiltersText } = props;

  return (
    <React.Fragment>
      <div ref={ref} data-testid="precise_filters" className={styles['precise-filters']}>
        <div>
          <MoreFiltersBtn buttonText={moreFiltersText} onClick={onMoreFiltersButtonClick} count={mainBtnCount} />
        </div>
      </div>
      <AllFiltersModal {...props} />
    </React.Fragment>
  );
};

_PreciseFilters.displayName = 'PreciseFilters';

export const PreciseFilters = React.forwardRef(_PreciseFilters);
